package com.sweetlime.dungeonamigo.util

object UsernameGenerator {
    private val adjectives = listOf("brave", "swift", "iron", "shadow", "silver", "storm", "wild", "frost")
    private val nouns = listOf("ranger", "mage", "paladin", "rogue", "druid", "bard", "monk", "cleric")
    fun generate(): String {
        val adj  = adjectives.random()
        val noun = nouns.random()
        val num  = (100..999).random()
        return "$adj$noun$num"
    }
}
